// extracted by mini-css-extract-plugin
export default {"zoomImageModal":"zoomImageModal_zoomImageModal__JR+tr","show":"zoomImageModal_show__gpCek","content":"zoomImageModal_content__lsPyT","closeBtn":"zoomImageModal_closeBtn__EiJg-"};